// hooks
import { useQuery } from 'react-query';
import { getUsersEmployees } from 'RestAPIs/employees';
import { toLocalISOString } from 'utils/date';

type UseGetUsersEmployeesArgs = {
  date?: Date | null;
  onlyFlex: boolean;
};

const useGetUsersEmployees = (
  { date, onlyFlex }: UseGetUsersEmployeesArgs,
  options: Record<string, any> = {}
) => {
  // convert once, so the query key holds exactly what is sent to the endpoint.
  // an absent date must stay absent: converting it would resolve to "now" and
  // change the key on every render
  const isEmployedOn = date ? toLocalISOString(date) : null;

  return useQuery(
    ['usersEmployees', isEmployedOn, onlyFlex],
    async () => {
      if (!isEmployedOn) {
        return [];
      }

      const { data } = await getUsersEmployees(isEmployedOn, onlyFlex);
      return data;
    },
    { ...options }
  );
};

export default useGetUsersEmployees;
